import { useMemo } from 'react';
import styles from './styles.module.scss';
import useTranslation from 'next-translate/useTranslation';
import { Animation } from '@starsoft/common/components';

export default function HomeAboutUsTopics() {
  const { t } = useTranslation('common');

  const Topic = useMemo(
    () =>
      Array.from({ length: 3 }).map((_, index) => (
        <div key={`topic-${index + 1}`} className={styles.container__topic}>
          <div className={styles.container__topic__point} />
          <Animation type="fadeInRight">
            <h3>{t(`about_us_topic.${index + 1}`)}</h3>
          </Animation>
        </div>
      )),
    [t],
  );

  return <div className={styles.container}>{Topic}</div>;
}
